<template>
  <div class="makent">
    <div class="makent-background">
      <div class="cardnber-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        欧堡利亚医院
      </div>
      <router-link :to="{path: 'hospital'}">
        <div class="makent-rotaon">
          <img src="../../public/obraoag/rotain.png" alt="">
        </div>
      </router-link>
      <div class="makent-projct">
        <div class="makent-projct-left">
          <div class="makent-projct-left-heit">
            <img src="../../public/obraoag/makentig.png" alt="">
          </div>
          <div class="makent-projct-left-text">
            <p>{{mantam}}</p>
            <p>体检卡号: {{maprum}}</p>
          </div>
        </div>
        <div class="makent-projct-right" v-if="this.maapus == '0'">
          <router-link :to="{path: 'choact',query: {macaon: this.mamoid,magect: this.maatnm,mascte: this.mareul,maewag: this.maprum,mapuer: this.mabier,mawage: this.mantam}}" v-if="this.macras == '0'"><span>查看</span></router-link>
          <router-link :to="{path: 'Fillon',query: {masier: this.maprum}}" v-else><span>预约</span></router-link>
        </div>
        <div class="makent-projct-right makent-projct-notble makent-projct-alused" v-else-if="this.maapus == '1'"><span>已使用</span></div>
        <div class="makent-projct-right makent-projct-notble" v-else-if="this.maapus == '2'"><span>过期</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      mantam: '',
      maprum: '',
      macras: '',
      maapus: '',
      mamoid: '',
      maatnm: '',
      mareul: '',
      mabier: ''
    }
  },
  created () {
    // 接收卡账号里传过来的体检卡信息
    this.mantam = this.$route.query.ventam;
    this.maprum = this.$route.query.veprum;
    this.macras = this.$route.query.vecras;
    this.maapus = this.$route.query.veapus;
    this.mamoid = this.$route.query.vemoid;
    this.maatnm = this.$route.query.veatnm;
    this.mareul = this.$route.query.vereul;
    this.mabier = this.$route.query.vebier;
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/makent.css";
</style>